import { Nav, NavItem, NavLink } from "reactstrap";
import React, { Fragment, useCallback, useState } from "react";
import { Btn } from "../../../../../AbstractElements";
import CreateSubServiceModal from "../createSubServicesModal";
import CreateFormModal from "../createFormModal";

const TABS = [
  // { id: "1", label: "Tree view" },
  { id: "2", label: "Service Detail" },
  // { id: "3", label: "Edit service" },
  // { id: "4", label: "Sub services" },
];

const NavComponent = ({ callbackActive, activeTab, reload }) => {
  const [isSubServiceModalOpen, setSubServiceModalOpen] = useState(false);
  const [isCreateFormModalOpen, setCreateFormModalModalOpen] = useState(false);

  const toggleSubService = useCallback(() => {
    setSubServiceModalOpen(!isSubServiceModalOpen);
    if (reload) {
      reload(!isSubServiceModalOpen);
    }
  }, [isSubServiceModalOpen, reload]);

  const toggleCreateForm = useCallback(() => {
    console.log("cancel form");
    setCreateFormModalModalOpen(!isCreateFormModalOpen);
  }, [isCreateFormModalOpen]);

  return (
    <Fragment>
      <CreateSubServiceModal
        isOpen={isSubServiceModalOpen}
        toggle={toggleSubService}
      />
      <CreateFormModal
        isOpen={isCreateFormModalOpen}
        toggle={toggleCreateForm}
      />
      <Nav tabs className="align-items-center">
        {TABS.map((tab) => (
          <NavItem key={tab.id}>
            <NavLink
              href="#"
              active={activeTab === tab.id}
              onClick={(e) => {
                e.preventDefault();
                callbackActive(tab.id);
              }}
              style={{
                cursor: "pointer",
                padding: "0.5rem 1rem",
                ...(activeTab === tab.id
                  ? {
                      borderColor: "#7366ff",
                      borderBottomColor: "transparent",
                      color: "#7366ff",
                      background: "rgba(115, 102, 255, 0.08)",
                      boxShadow: "0 -3px 8px rgba(115, 102, 255, 0.18)",
                      fontWeight: 600,
                    }
                  : {
                      background: "transparent",
                      color: "#6c757d",
                    }),
              }}
            >
              {tab.label}
            </NavLink>
          </NavItem>
        ))}
        <NavItem className="ms-auto" style={{ paddingBottom: '0px' }}>
          <Btn
            attrBtn={{
              color: "primary",
              className: "btn-sm",
              onClick: toggleSubService,
            }}
          >
            + Add sub service
          </Btn>
        </NavItem>
      </Nav>
    </Fragment>
  );
};

export default NavComponent;
